// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__W913L","fromWhomItem":"styles_fromWhomItem__zaPwU","fromWhomActive":"styles_fromWhomActive__JDxAC"};
module.exports.__checksum = "f43157f2a71a"